import { anchorLink } from "./include/module";
(() => { anchorLink(); })();

import { pageTop } from "./include/module";
(() => { pageTop(); })();

import { headerMenuToggle } from "./include/module";
(() => { headerMenuToggle(); })();

import { pcHeaderLogo } from "./include/module";
(() => { pcHeaderLogo(); })();

import { idxScrollAnimation } from "./include/module";
(() => { idxScrollAnimation(); })();

import { idxEncoreModal } from "./include/module";
(() => { idxEncoreModal(); })();

import { idxTweetBox } from "./include/module";
(() => { idxTweetBox(); })();



// WEBPACK FOOTER //
// ./src/assets/js/index.js